import ConnectionNotSuccesful from "./connectionFailed";
import { Buttons } from "./connectionSuccessful";

export default function IntegrationConnectionFailed({
  onSubmit,
  onBack,
}: {
  onSubmit: React.Dispatch<React.SetStateAction<string>>;
  onBack: React.Dispatch<React.SetStateAction<string>>;
}) {
  return (
    <div className="mx-auto w-[379px] h-[326px] justify-between flex flex-col gap-[32px]">
      <ConnectionNotSuccesful onEdit={onBack} />
      <Buttons onSubmit={onSubmit} onBack={onBack} shouldDisable />
    </div>
  );
}
